import React from "react";
import { Box, Typography, useTheme } from "@mui/material";
import { useField } from "formik";
import { OcFormSwitch } from "oc/components";

interface OcSettingSwitchProps {
  label: string;
  info: string;
  disabled?: boolean;
  id?: string;
  name: string;
  isMobile?: boolean;
}

export const OcSettingSwitchFormik: React.FC<OcSettingSwitchProps> = ({
  label,
  info,
  disabled,
  id,
  name,
  isMobile,
}) => {
  const theme = useTheme();
  const [field, , helper] = useField(name);

  return (
    <Box
      display="flex"
      flexDirection={isMobile ? "column" : "row"}
      alignItems={isMobile ? "flex-start" : "center"}
    >
      <Box display="flex" flexDirection="row" alignItems="center">
        <Box
          width={isMobile ? "auto" : "200px"}
          textAlign="right"
          color={theme.palette.owGray.main}
        >
          <Typography variant="caption" color={theme.palette.owGray.main}>
            {label}
          </Typography>
        </Box>
        <Box width="16px" />
        <OcFormSwitch
          name={name}
          id={id}
          checked={field.value}
          onChange={() => {
            helper.setValue(!field.value);
          }}
          inputProps={{ "aria-label": "controlled" }}
          disabled={disabled}
        />
      </Box>
      <Box width="16px" />
      {isMobile && <Box height="16px" />}
      <Box width="300px">
        <Box
          fontSize="12px"
          letterSpacing="0.4px"
          color={theme.palette.owGray.main}
          width="300px"
        >
          {info}
        </Box>
      </Box>
    </Box>
  );
};
